/**
 * Shown when an authenticated user reaches an admin route their role does not
 * cover — either because the SPA guard caught it, or because the API returned
 * 403 on a screen the guard let through (a support user opening a WRITE-gated
 * surface, say).
 *
 * The copy deliberately does NOT say what the staff area contains or list the
 * roles that would have worked. A 403 page is a fine place to leak an org
 * chart, and an ordinary customer who mistypes a URL should learn nothing from
 * it beyond "not for you".
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function ForbiddenPage({ detail }: { detail?: string }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] grid place-items-center px-4">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl border border-white/10 bg-white/[0.04] text-white/40">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
            <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
          </svg>
        </div>
        <h1 className="font-display text-2xl font-extrabold">Not available on this account</h1>
        <p className="mt-2.5 text-sm leading-relaxed text-white/50">
          {detail ??
            'You’re signed in, but this area isn’t part of your account. If you think that’s wrong, ask whoever set up your access.'}
        </p>
        <Button variant="secondary" className="mt-6" onClick={() => navigate('/bets')}>
          Back to Puntsave
        </Button>
      </div>
    </div>
  );
}
